var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{class:{ 'sr-only': _vm.hide_label },attrs:{"for":'input-' + _vm.id}},[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_c('date-picker',{attrs:{"id":'input-' + _vm.id,"placeholder":_vm.text,"config":_vm.config},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ed32f4c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/templates/InputDate/InputDate.vue
// module id = null
// module chunks = 